<template>
    <div class="Desktop">
        <img :src="require('@/commons/img/crystal.png')" class="Desktop__crystal" />
        <img :src="require('@/commons/img/crystal-2.png')" class="Desktop__crystal2" />
        <div class="Desktop__container">  
            <div class="Desktop__trigger"/>
            <div class="Desktop__header">
                <div class="Desktop__header-block">MOMENTA BIENNALE DE L'IMAGE</div>
                <div class="Desktop__header-block lang" @click="$root.langSwitch()">{{ this.getLang() }}</div>
            </div>  
            <div id="is-double" class="Desktop__block double">   
                <div class="Desktop__sublock left">    
                    <div class="Desktop__title" v-html="trans('DESKTOP.title')"/>
                    <div class="Desktop__description" v-html="trans('DESKTOP.description')"/>
                    <div id="down-1" class="Desktop__down">
                        <img :src="require('@/commons/img/desktop/down.png')"/>
                        <div class="Desktop__down-txt">{{ trans('DESKTOP.more') }}</div>
                    </div>
                </div>
                <div id="iphone-1" class="Desktop__sublock">    
                    <div class="Desktop__iphone">
                        <img :src="require('@/commons/img/desktop/map.png')"/>

                        <div class="Desktop__iphone-txt">
                            <div class="Desktop__iphone-txt-title" v-html="trans('FONT.title')"/>
                            <div class="Desktop__iphone-txt-subtitle" v-html="trans('FONT.subtitle')"/>
                        </div>
                    </div>
                </div>
            </div>
            <div id="block-1" class="Desktop__block">  
                <div id="title-1" class="Desktop__row-title" v-html="trans('FONT.title')"/>
                <div id="desc-1" class="Desktop__row-description" v-html="trans('DESKTOP.texte')"/>
                <div id="img-1" class="Desktop__row-image">

                    <!-- <img :src="require('@/commons/img/desktop/image.png')"/> -->

                    <video ref="video" width="100%" height="100%" controls :key="this.lang" :poster="require('@/commons/img/desktop/poster.png')">
                        <source :src="require('@/commons/videos/momenta_'+ this.lang +'.mp4')" type="video/mp4" >
                    </video> 


                </div>
                <div id="bottom-1" class="Desktop__block bottom">  
                    <div id="bottom-title" class="Desktop__title bottom" v-html="trans('DESKTOP.footer')" />
                    <div id="bottom-scrolltop" class="Desktop__scrolltop" @click="scrollTop()">{{ trans('GLOBAL.back_to_top') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script> 

import Mixin from '@/mixins/Smooth.js'
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import MotionPathPlugin from "gsap/MotionPathPlugin"
import ScrollToPlugin from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, ScrollToPlugin)

export default {

    name: 'Desktop',
    mixins: [Mixin],
    components: {  },
    data: () => ({
        width: window.innerWidth,
        height: window.innerHeight,
    }),

    mounted() {   
        this.$nextTick(()=>{

            gsap.to("#title-1", {
                y: '-400px',
                ease: "none",
                scrollTrigger: {
                    trigger: "#title-1",
                    start: "0% 65%", // the default values
                    end: "0% 25%",
                    scrub: true,
                    // markers: true
                }, 
            })

            gsap.to("#desc-1", {
                y: '-400px',
                ease: "none",
                scrollTrigger: {
                    trigger: "#desc-1",
                    start: "0% 95%", // the default values
                    end: "0% 60%",
                    scrub: true,
                    // markers: true
                }, 
            })

            gsap.to("#img-1", {
                y: '-400px',
                ease: "none",
                scrollTrigger: {
                    trigger: "#img-1",
                    start: "0% 95%", // the default values
                    end: "0% 60%",
                    scrub: true,
                    // markers: true
                }, 
            })

            gsap.to("#iphone-1", {
              y: '-600px',
              ease: "none",
              scrollTrigger: {
                trigger: "#iphone-1",
                start: "0% 5%", // the default values
                end: "0% -50%",
                scrub: true,
                // markers: true
              }, 
            })

            gsap.to("#down-1", {
              y: '-400px',
              ease: "none",
              scrollTrigger: {
                trigger: "#down-1",
                start: "0% 40%", // the default values
                end: "0% 0%",
                scrub: true,
                // markers: true
              }, 
            })

            gsap.to(".Desktop__title", {
              y: '-100px',
              ease: "none",
              scrollTrigger: {
                trigger: ".Desktop__title",
                start: "0% 20%", // the default values
                end: "0% 0%",
                scrub: true,
                // markers: true
              }, 
            })

            gsap.to(".Desktop__description", {
              y: '-550px',
              ease: "none",
              scrollTrigger: {
                trigger: ".Desktop__description",
                start: "0% 20%", // the default values
                end: "0% 0%",
                scrub: true,
                // markers: true
              }, 
            })

           gsap.to("#bottom-title", {
              y: '-400px',
              ease: "none",
              scrollTrigger: {
                trigger: "#bottom-title",
                start: "0% 80%", // the default values
                end: "0% 10%",
                scrub: true,
                // markers: true
              }, 
            })

           gsap.to("#bottom-scrolltop", {
              y: '-300px',
              ease: "none",
              scrollTrigger: {
                trigger: "#bottom-scrolltop",
                start: "0% 80%", // the default values
                end: "0% 5%",
                scrub: true,
                // markers: true
              }, 
            })
            
        })
    },
    methods: {  
        getLang() {
            return this.lang == 'fr' ? 'EN' : 'FR'
        },
        scrollTop() {
            gsap.to(window, {
                scrollTo: {
                  y: 0,
                  autoKill: true
                },
                duration: .75,
                ease: 'cubic.easeOut'
            })
        },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'
@import '~@/commons/stylus/Hamburger-icon'

.Desktop 
    color black
    display flex
    align-items flex-start
    justify-content center
    top 0
    left 0
    width 100vw
    // background url('~@/commons/img/desktop/background.png') no-repeat center center fixed
    // background-size cover
    position relative
    overflow hidden

    &__container 
        padding 0 32px
        position relative
        display flex
        flex-direction column
        align-items center
        
    &__header 
        width 100vw
        height 122px
        text-transform uppercase
        font-size 22px
        display flex 
        justify-content space-between

        &-block 
            padding 8px 16px

            &.lang 
                cursor pointer
                height 64px

                &:hover
                    text-decoration underline

    &__block 
        display flex 
        flex-direction column
        align-items center
        justify-content flex-start
        width 100%
        max-width 1024px 

        &.double 
            flex-direction row
            justify-content center
            align-items flex-start

        &.bottom
            align-items flex-start

    &__sublock
        width 50%
        display flex 
        flex-direction column
        align-items center
        justify-content flex-start

        &.left
            align-items flex-start

    &__title 
        font-family Ringside
        font-size 42px
        line-height 40px
        padding-top 58px
        padding-bottom 32px

        &.bottom
            width 50%
            font-size 32px
            line-height 32px
            position relative

    &__description
        font-family Ringside
        font-size 18px
        font-weight 200
        max-width 80%

    &__down
        padding-top 40%
        display flex
        flex-direction row
        align-items center

        &-txt 
            padding-left 32px

    &__row 
        &-title 
            font-family Jugendreisen
            font-size 72px
            text-transform uppercase
            line-height 80px
            text-align center
            padding 108px 0 32px
           
        &-description 
            text-align center
            font-family Ringside
            font-weight 200
            padding 0 32px 108px           

        &-image 
            width 100%
            height 100%
            padding 0 0 108px

    &__scrolltop 
        cursor pointer

    &__iphone 
        position relative

        &-txt 
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
            font-family Jugendreisen
            text-align center
            text-transform uppercase

            &-title
                font-size 42px
                line-height 46px
                padding-bottom 32px

            &-subtitle 
                font-size 18px
                line-height 24px

    &__trigger
        width 10vw
        left 0
        height 1px
        z-index 200
        pointer-events none

    &__crystal
        position absolute
        bottom -5%

    &__crystal2
        position absolute
        top 10%
        left -250px
       
</style>


